export default {
  props: {
    title: {
      type: Object,
    },

    body: {
      type: String,
    },

    cards: {
      type: [Array, Object],
    },

    theme: {
      type: String,
      default: '',
      validator: prop => ['', 'light'].includes(prop),
    },
  },
  computed: {
    isLightTheme() {
      if (this.theme === 'light') return true

      return false
    },
  },
}
